(function () {
  let toastTimer;

  function ensureToastRoot() {
    let root = document.getElementById('bm-toast-root');
    if (!root) {
      root = document.createElement('div');
      root.id = 'bm-toast-root';
      root.setAttribute('aria-live', 'polite');
      root.setAttribute('aria-atomic', 'true');
      document.body.appendChild(root);
    }
    return root;
  }

  function showToast(message) {
    clearTimeout(toastTimer);
    const root = ensureToastRoot();
    root.innerHTML = `
      <div class="bm-toast" role="status">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8FCFAF" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>
        <span class="bm-toast__message">${message}</span>
        <button type="button" class="bm-toast__dismiss">Dismiss</button>
      </div>
    `;
    const toast = root.querySelector('.bm-toast');
    const dismiss = () => {
      toast.remove();
      clearTimeout(toastTimer);
    };
    root.querySelector('.bm-toast__dismiss').addEventListener('click', dismiss);
    toastTimer = setTimeout(dismiss, 2600);
  }

  function refreshCartBubble() {
    fetch(`${window.routes ? window.routes.cart_url : '/cart'}?section_id=cart-icon-bubble`)
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = doc.querySelector('.shopify-section');
        const target = document.getElementById('cart-icon-bubble');
        if (content && target) target.innerHTML = content.innerHTML;
      })
      .catch(() => {});
  }

  function addToCart(variantId, quantity, label) {
    if (!variantId) return Promise.reject(new Error('Missing variant id'));

    return fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          const message = (data.description || data.message || 'Could not add that to your cart.');
          showToast(message);
          if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartError, { source: 'bm-cart', message });
          }
          throw new Error(message);
        }
        const shortName = label || (data.product_title || 'Item').split('|')[0].trim();
        showToast(`${shortName} added to your cart`);
        refreshCartBubble();
        if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bm-cart', cartData: data });
        }
        return data;
      });
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-bm-add-to-cart]');
    if (!trigger) return;
    event.preventDefault();
    if (trigger.disabled) return;

    const variantId = trigger.getAttribute('data-variant-id');
    let label = trigger.getAttribute('data-product-label');
    if (label) label = label.split('|')[0].trim();
    const originalText = trigger.textContent;
    trigger.disabled = true;

    addToCart(variantId, 1, label)
      .catch(() => {})
      .finally(() => {
        trigger.disabled = false;
        trigger.textContent = originalText;
      });
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-bm-buy-now]');
    if (!trigger) return;
    event.preventDefault();
    if (trigger.disabled) return;

    const variantId = trigger.getAttribute('data-variant-id');
    const originalText = trigger.textContent;
    trigger.disabled = true;
    trigger.textContent = 'Redirecting to checkout…';

    addToCart(variantId, 1)
      .then(() => { window.location.href = '/checkout'; })
      .catch(() => {
        trigger.disabled = false;
        trigger.textContent = originalText;
      });
  });

  window.bmAddToCart = addToCart;
  window.bmShowToast = showToast;
})();
